<template>
  <v-dialog
    :value="show"
    max-width="800"
    persistent
    @input="$emit('update:show', $event)"
  >
    <v-card>
      <v-card-actions class="justify-end">
        <v-icon
          text
          @click="handleClose"
        >
          mdi-close-thick
        </v-icon>
      </v-card-actions>
      <v-toolbar
        style="background-color:rgb(204 33 40);color:white !important"
        dark
      >
        <strong>Editar Cliente </strong>- {{ client.name }}
      </v-toolbar>
      <v-card-text style="padding-top: 20px;">
        <v-form ref="formEditClient">
          <v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="editedClient.legal_name"
                label="Razón Social"
                prepend-inner-icon="mdi-domain"
                clearable
                :rules="[v => !!v || 'Este campo es requerido']"
                required
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="editedClient.ruc"
                label="RUC"
                prepend-inner-icon="mdi-card-account-details"
                clearable
                maxlength="13"
                :rules="rucRules"
                required
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="editedClient.name"
                label="Nombre Establecimiento"
                prepend-inner-icon="mdi-account-tie"
                clearable
                :rules="[v => !!v || 'Este campo es requerido']"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="editedClient.main_address"
                label="Dirección Matriz"
                prepend-inner-icon="mdi-store-marker"
                clearable
                :rules="[v => !!v || 'Este campo es requerido']"
                required
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="editedClient.ruc_provider_fe"
                label="RUC Proveedor FE"
                prepend-inner-icon="mdi-card-account-details-outline"
                clearable
                maxlength="13"
                :rules="rucRules"
                required
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="editedClient.status"
                :items="typeEnvironment"
                item-text="textEnvironment"
                item-value="valueEnvironment"
                label="Ambiente"
                prepend-inner-icon="mdi-sitemap"
                :rules="[v => !!v || 'Este campo es requerido']"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="editedClient.email"
                label="Correo Electrónico"
                prepend-inner-icon="mdi-email"
                clearable
                :rules="[
                  v => !!v || 'Este campo es requerido',
                  v => /.+@.+\..+/.test(v) || 'El correo no es válido'
                ]"
                required
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="editedClient.url_image"
                label="URL Imagen Logo"
                prepend-inner-icon="mdi-file-image"
                clearable
              />
              <div v-if="editedClient.url_image">
                <span class="text-caption">Vista previa:</span>
                <div id="preview">
                  <img
                    style="width:60%; max-height: 100px; object-fit: contain;"
                    :src="editedClient.url_image"
                  >
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="msgResponse">
            <v-col cols="12">
              <v-alert
                :type="alertType"
                text
              >
                {{ msgResponse }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row
            v-if="progress"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col cols="6">
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                Actualizando Cliente
              </v-col>
              <v-progress-linear
                color="red darken-4"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="handleClose"
        >
          Cancelar
        </v-btn>
        <v-btn
          text
          style="background-color:rgb(204 33 40);color:white !important"
          @click="handleUpdate"
        >
          Actualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { listEnvironment } from '@/data/listEnvironment'

  export default {
    name: 'EditClientModal',
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      client: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        editedClient: {},
        msgResponse: '',
        progress: false,
        typeEnvironment: listEnvironment,
        alertType: 'success',
        rucRules: [
          (v) => !!v || 'Este campo es requerido',
          (v) => /^\d{13}$/.test(v) || 'El RUC debe contener 13 dígitos numéricos',
        ],
      }
    },
    watch: {
      client: {
        handler (newClient) {
          if (newClient && Object.keys(newClient).length > 0) {
            this.editedClient = { ...newClient }
          }
        },
        deep: true,
        immediate: true,
      },
      show (newVal) {
        if (!newVal) {
          this.msgResponse = ''
          this.progress = false
          this.alertType = 'success'
        }
      },
    },
    methods: {
      handleClose () {
        this.msgResponse = ''
        this.progress = false
        this.alertType = 'success'
        this.$emit('close')
      },
      async handleUpdate () {
        if (!this.$refs.formEditClient.validate()) {
          return
        }

        this.progress = true
        this.msgResponse = ''
        this.alertType = 'success'

        try {
          const payload = {
            IdCompania: this.editedClient.id,
            NombreCompania: this.editedClient.name,
            RazonSocial: this.editedClient.legal_name,
            RUC: this.editedClient.ruc,
            Estado: this.editedClient.status,
            CorreoElectronico: this.editedClient.email,
            DireccionMatriz: this.editedClient.main_address,
            RucProveedorFE: this.editedClient.ruc_provider_fe,
            URLImagen: this.editedClient.url_image,
          }

          await this.$store.dispatch('clients/updateClient', payload)

          this.progress = false
          this.alertType = 'success'
          this.msgResponse = 'Cliente actualizado exitosamente'

          setTimeout(() => {
            this.$emit('updated')
            this.handleClose()
          }, 2000)
        } catch (error) {
          this.progress = false
          this.alertType = 'error'
          this.msgResponse = error.message || 'Error al actualizar el cliente'
          console.error(error)
        }
      },
    },
  }
</script>

<style scoped>
</style>
